app.controller("AddSeasonController", [
  "$scope", "Season", "$uibModalInstance", "StaticData",
  function($scope, Season, $uibModalInstance, StaticData) {

    function generateSeasonOptions() {
      StaticData.getItemsByKey("subject_seasons")
        .then(function (seasons) {
          $scope.seasonOptions = seasons.map(function (season) {
            return season.name;
          });
        });
    }

    function generateYearOptions() {
      var startYear = 2017; // project started in 2017
      var endYear = new Date().getFullYear() + 2;

      $scope.yearOptions = []

      for (var i = 2017; i <= endYear; i++) {
        $scope.yearOptions.push(i);
      }
    }

    generateSeasonOptions();
    generateYearOptions();

    console.log($scope.yearOptions);

    $scope.create = function() {
      Season.add({
        year: $scope.year,
        season: $scope.season
      }).then(function() {
        $uibModalInstance.close();
      });
    };

    $scope.close = function() {
      $uibModalInstance.dismiss();
    };
  }
]);
